export enum CategoryShowTypeEnum {
	MAIN_CATEGORY = 'main',
	SUB_CATEGORY = 'sub',
	ALL_CATEGORY = 'all',
	DEFAULT = 'default',
}
